import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "ethnicGroup",
  listPath: "ethnic/group",
  adminPath: "ethnic/group",
  legacy: {
    data: "ethnicGroup",
    count: "count",
    fetch: "fetchEthnicGroups",
    create: "createOneEthnicGroup",
    update: "updateEthnicGroup",
    remove: "deleteEthnicGroup",
    updateState: "updateEthnicGroupState",
  },
});

export const EthnicGroupProvider = Provider;
export const useEthnicGroupContext = useValue;
